import { Grid, Typography } from "@mui/material";
import { FieldArray, Form } from "formik";
import React, { useEffect, useRef } from "react";
import { useIntl } from "react-intl";
import Input from "../../../../components/Input";
import AddIcon from "@material-ui/icons/Add";
import CheckIcon from "@material-ui/icons/Check";
import SettingsBackupRestoreIcon from "@material-ui/icons/SettingsBackupRestore";
import MaterialPreview from "../../../../components/MaterialPreview";
import Upload from "../../../../components/Upload";
import RemoveIcon from "@material-ui/icons/Remove";
import PropTypes from "prop-types";
import { showHideSnackbar } from "../../../../store/Snackbar/actions";
import { useDispatch } from "react-redux";

function TestAnswerForm({
  question,
  questionIndex,
  setFieldValue,
  formRef,
  mode,
  isDicom
}) {
  const uploadAnswerRef = useRef();
  const { messages } = useIntl();
  const {
    preTestPostTest: {
      answersOptions,
      answerText,

      upload
    }
  } = messages;
  const dispatch = useDispatch();

  const setTabValue = (setFieldValue, type) => {
    const newArray = [];
    question.test_answer_choices_attributes.forEach((answer) => {
      if (answer?.id) {
        let deletedAns = {
          ...answer,
          correct: false,
          _destroy: true
        };
        newArray.push(deletedAns);
      }
    });

    const withTwoEmptyValues = [
      ...newArray,
      ...[
        {
          answer: "",
          correct: false,
          justification: "",
          image_url: "",
          currentTab: type
        },
        {
          answer: "",
          correct: false,
          justification: "",
          image_url: "",
          currentTab: type
        }
      ]
    ];

    question.test_answer_choices_attributes = withTwoEmptyValues;

    setFieldValue(
      `test_questions_attributes[${questionIndex}]`,
      question
    );
  };

  const AddAnswer = (push, question) => {
    return () => {
      push({
        answer: "",
        currentTab:
          question.test_answer_choices_attributes[0].currentTab,
        image_url: "",
        correct: false,
        justification: ""
      });
    };
  };

  const removeAnswer = (replace, answerIndex, answer) => {
    return () => {
      replace(answerIndex, {
        ...answer,
        correct: false,
        _destroy: true
      });
    };
  };

  async function handleUploadSingleImage(e, qIndex, AIndex, type) {
    let file = e?.target?.files[0];
    if (file) {
      if (file?.type?.includes("image")) {
        let url = URL.createObjectURL(file);
        let objFile = { file, url };

        if (type == "answer") {
          formRef.current.setFieldValue(
            `test_questions_attributes[${qIndex}].test_answer_choices_attributes[${AIndex}].image_url`,
            objFile
          );
          if (uploadAnswerRef.current)
            uploadAnswerRef.current.value = null;
        }
        // Clear input value
        e.target.value = null;
      } else {
        dispatch(
          showHideSnackbar({
            type: "error",
            isOpen: true,
            message: "Please select image"
          })
        );
      }
    }
  }

  function getCurrentTab(answers) {
    const hasText = answers?.some(
      (a) => a.answer && a.answer.trim() !== ""
    );
    const hasImage = answers?.some(
      (a) => a.image_url && a.image_url !== ""
    );

    if (hasText && hasImage) {
      console.log("text_image");
      return "text_image";
    }
    if (hasImage) {
      console.log("image");
      return "image";
    }
    if (hasText) {
      console.log("text");
      return "text";
    }

    return "text";
  }

  useEffect(() => {
    if (mode === "edit") {
      const currentTab = getCurrentTab(
        question.test_answer_choices_attributes
      );
      console.log("currentTab", currentTab);

      question.test_answer_choices_attributes
        .filter((answer) => {
          console.log(" answer._destroy ", answer._destroy);
          return answer._destroy !== true;
        })
        .forEach((answer, answerIndex) => {
          if (answer.currentTab !== currentTab) {
            setFieldValue(
              `test_questions_attributes[${questionIndex}].test_answer_choices_attributes[${answerIndex}].currentTab`,
              currentTab
            );
          }
        });
    }
  }, [
    question.test_answer_choices_attributes,
    questionIndex,
    setFieldValue,
    mode
  ]);
  return (
    <FieldArray
      name={`test_questions_attributes[${questionIndex}].test_answer_choices_attributes`}
    >
      {({ push, replace, remove }) => {
        return (
          <Form>
            <Typography
              variant="h6"
              component="h6"
              className="text-secondary my-4"
            >
              {answersOptions}
            </Typography>
            <ul className="nav nav-tabs">
              <li className="nav-item" role="presentation">
                <button
                  className={
                    question?.test_answer_choices_attributes[0]
                      .currentTab === "text"
                      ? "nav-link active"
                      : "nav-link"
                  }
                  data-bs-toggle="tab"
                  data-bs-target={`#text_${questionIndex}`}
                  type="button"
                  role="tab"
                  aria-controls={`text_${questionIndex}`}
                  aria-selected="false"
                  onClick={() => setTabValue(setFieldValue, "text")}
                >
                  Text
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={
                    question.test_answer_choices_attributes[0]
                      .currentTab === "image"
                      ? "nav-link active"
                      : "nav-link"
                  }
                  data-bs-toggle="tab"
                  data-bs-target={`#image_${questionIndex}`}
                  type="button"
                  role="tab"
                  aria-controls={`image_${questionIndex}`}
                  aria-selected="false"
                  onClick={() => setTabValue(setFieldValue, "image")}
                >
                  Image
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={
                    question.test_answer_choices_attributes[0]
                      .currentTab === "text_image"
                      ? "nav-link active"
                      : "nav-link"
                  }
                  data-bs-toggle="tab"
                  data-bs-target={`#image_text_${questionIndex}`}
                  type="button"
                  role="tab"
                  aria-controls={`image_text_${questionIndex}`}
                  aria-selected="false"
                  onClick={() =>
                    setTabValue(setFieldValue, "text_image")
                  }
                >
                  Image with Text
                </button>
              </li>
            </ul>
            <div className="tab-content py-4" id="myTabContent">
              <div
                className={
                  getCurrentTab(
                    question.test_answer_choices_attributes
                  ) === "text"
                    ? "tab-pane fade show active"
                    : "tab-pane fade"
                }
                id={`text_${questionIndex}`}
                role="tabpanel"
                aria-labelledby={`text_${questionIndex}`}
              >
                {question.test_answer_choices_attributes.map(
                  (answer, answerIndex, arr) => {
                    return (
                      !answer._destroy && (
                        <div
                          className="mx-5 d-flex"
                          key={JSON.stringify(answerIndex)}
                        >
                          <div className="flex-fill">
                            <Input
                              name={`test_questions_attributes[${questionIndex}].test_answer_choices_attributes[${answerIndex}].answer`}
                              label={answerText}
                              isRequired={true}
                            />
                          </div>
                          <div className="mx-2">
                            {arr?.filter((x) => !x._destroy)[0] && (
                              <div className="d-flex">
                                <AddIcon
                                  className="me-2 mt-2 cursor-pointer"
                                  onClick={() => {
                                    push({
                                      answer: "",
                                      currentTab:
                                        question
                                          .test_answer_choices_attributes[0]
                                          .currentTab,
                                      image_url: "",
                                      correct: false,
                                      justification: ""
                                    });
                                  }}
                                />
                                {}
                                <div className="mx-2 mt-2 cursor-pointer">
                                  {question.test_answer_choices_attributes.every(
                                    (el) => el.correct === false
                                  ) === true ? (
                                    <CheckIcon
                                      color="success"
                                      className="me-2"
                                      onClick={() => {
                                        replace(answerIndex, {
                                          ...answer,
                                          correct: true
                                        });
                                      }}
                                    />
                                  ) : (
                                    question
                                      .test_answer_choices_attributes[
                                      answerIndex
                                    ].correct === true && (
                                      <SettingsBackupRestoreIcon
                                        onClick={() => {
                                          replace(answerIndex, {
                                            ...answer,
                                            correct: false
                                          });
                                        }}
                                      />
                                    )
                                  )}
                                </div>
                              </div>
                            )}
                          </div>

                          {question.test_answer_choices_attributes.filter(
                            (x) => !x._destroy
                          ).length > 2 && (
                            <div className="mx-2 mt-2 cursor-pointer">
                              <RemoveIcon
                                className="me-2"
                                onClick={() => {
                                  if (!answer.id) {
                                    remove(answerIndex);
                                    return;
                                  }
                                  replace(answerIndex, {
                                    ...answer,
                                    answer: "deleted",
                                    correct: false,

                                    _destroy: true
                                  });
                                }}
                              />
                            </div>
                          )}
                        </div>
                      )
                    );
                  }
                )}
              </div>

              <div
                className={
                  mode === "edit" &&
                  getCurrentTab(
                    question.test_answer_choices_attributes
                  ) === "image"
                    ? "tab-pane fade show active"
                    : "tab-pane fade"
                }
                id={`image_${questionIndex}`}
                role="tabpanel"
                aria-labelledby={`image_${questionIndex}`}
              >
                {question.test_answer_choices_attributes.map(
                  (answer, answerIndex, arr) => {
                    return (
                      !answer._destroy && (
                        <div
                          className="mx-5 d-flex"
                          key={JSON.stringify(answerIndex)}
                        >
                          <div className="flex-fill">
                            <Grid item xs={6} className="pb-0">
                              <div className="d-flex flex-column align-items-center text-center">
                                <div className="mb-3 d-flex flex-column align-items-center w-100">
                                  <MaterialPreview
                                    type={1}
                                    isPublic={false}
                                    src={
                                      answer.image_url.url ||
                                      answer.image_url
                                    }
                                    hasClear={true}
                                    onClear={() => {
                                      setFieldValue(
                                        `test_questions_attributes[${questionIndex}].test_answer_choices_attributes[${answerIndex}].image_url`,
                                        ""
                                      );
                                    }}
                                  />
                                </div>
                                <Upload
                                  ref={uploadAnswerRef}
                                  onChange={(e) =>
                                    handleUploadSingleImage(
                                      e,
                                      questionIndex,
                                      answerIndex,
                                      "answer"
                                    )
                                  }
                                  label={upload}
                                  name={`test_questions_attributes[${questionIndex}].test_answer_choices_attributes[${answerIndex}].image_url`}
                                  accept="image/*"
                                  isImage={true}
                                  setFieldValue={setFieldValue}
                                  isRequired={true}
                                  isMultiple={isDicom ? true : false}
                                />
                              </div>
                            </Grid>
                          </div>
                          <div className="mx-2">
                            {arr?.filter((x) => !x._destroy)[0] && (
                              <div className="d-flex">
                                <AddIcon
                                  className="me-2 mt-2 cursor-pointer"
                                  onClick={() => {
                                    push({
                                      answer: "",
                                      currentTab:
                                        question
                                          .test_answer_choices_attributes[0]
                                          .currentTab,
                                      image_url: "",
                                      correct: false,
                                      justification: ""
                                    });
                                  }}
                                />
                                <div className="mx-2 mt-2 cursor-pointer">
                                  {question.test_answer_choices_attributes.every(
                                    (el) => el.correct === false
                                  ) === true ? (
                                    <CheckIcon
                                      color="success"
                                      className="me-2"
                                      onClick={() => {
                                        replace(answerIndex, {
                                          ...answer,
                                          correct: true
                                        });
                                      }}
                                    />
                                  ) : (
                                    question
                                      .test_answer_choices_attributes[
                                      answerIndex
                                    ].correct === true && (
                                      <SettingsBackupRestoreIcon
                                        onClick={() => {
                                          replace(answerIndex, {
                                            ...answer,
                                            correct: false
                                          });
                                        }}
                                      />
                                    )
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                          {question.test_answer_choices_attributes.filter(
                            (x) => !x._destroy
                          ).length > 2 && (
                            <div className="mx-2 mt-2 cursor-pointer">
                              <RemoveIcon
                                className="me-2"
                                onClick={() =>
                                  replace(answerIndex, {
                                    ...answer,
                                    correct: false,

                                    _destroy: true
                                  })
                                }
                              />
                            </div>
                          )}
                        </div>
                      )
                    );
                  }
                )}
              </div>
              <div
                className={
                  mode === "edit" &&
                  getCurrentTab(
                    question.test_answer_choices_attributes
                  ) === "text_image"
                    ? "tab-pane fade show active"
                    : "tab-pane fade"
                }
                id={`image_text_${questionIndex}`}
                role="tabpanel"
                aria-labelledby={`image_text_${questionIndex}`}
              >
                {question.test_answer_choices_attributes.map(
                  (answer, answerIndex, arr) => {
                    return (
                      !answer._destroy && (
                        <div
                          className="mx-5 d-flex"
                          key={JSON.stringify(answerIndex)}
                        >
                          <div className="flex-fill">
                            <Input
                              name={`test_questions_attributes[${questionIndex}].test_answer_choices_attributes[${answerIndex}].answer`}
                              label={answerText}
                              isRequired={true}
                            />
                            <div className="flex-fill">
                              <Grid item xs={6} className="pb-0">
                                <div className="d-flex flex-column align-items-center text-center">
                                  <div className="mb-3 d-flex flex-column align-items-center w-100">
                                    <MaterialPreview
                                      type={1}
                                      isPublic={false}
                                      src={
                                        answer.image_url.url ||
                                        answer.image_url
                                      }
                                      hasClear={true}
                                      onClear={() => {
                                        setFieldValue(
                                          `test_questions_attributes[${questionIndex}].test_answer_choices_attributes[${answerIndex}].image_url`,
                                          ""
                                        );
                                      }}
                                    />
                                  </div>
                                  <Upload
                                    ref={uploadAnswerRef}
                                    onChange={(e) =>
                                      handleUploadSingleImage(
                                        e,
                                        questionIndex,
                                        answerIndex,
                                        "answer"
                                      )
                                    }
                                    label={upload}
                                    name={`test_questions_attributes[${questionIndex}].test_answer_choices_attributes[${answerIndex}].image_url`}
                                    accept="image/*"
                                    isImage={true}
                                    setFieldValue={setFieldValue}
                                    isRequired={true}
                                    isMultiple={
                                      isDicom ? true : false
                                    }
                                  />
                                </div>
                              </Grid>
                            </div>
                          </div>
                          <div className="mx-2">
                            {arr?.filter((x) => !x._destroy)[0] && (
                              <div className="d-flex">
                                <AddIcon
                                  className="me-2 mt-2 cursor-pointer"
                                  onClick={AddAnswer(push, question)}
                                />
                                <div className="mx-2 mt-2 cursor-pointer">
                                  {question.test_answer_choices_attributes.every(
                                    (el) => el.correct == false
                                  ) === true ? (
                                    <CheckIcon
                                      color="success"
                                      className="me-2"
                                      onClick={() => {
                                        replace(answerIndex, {
                                          ...answer,
                                          correct: true
                                        });
                                      }}
                                    />
                                  ) : (
                                    question
                                      .test_answer_choices_attributes[
                                      answerIndex
                                    ].correct === true && (
                                      <SettingsBackupRestoreIcon
                                        onClick={() => {
                                          replace(answerIndex, {
                                            ...answer,
                                            correct: false
                                          });
                                        }}
                                      />
                                    )
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                          {question.test_answer_choices_attributes.filter(
                            (x) => !x._destroy
                          ).length > 2 && (
                            <div className="mx-2 mt-2 cursor-pointer">
                              <RemoveIcon
                                className="me-2"
                                onClick={removeAnswer(
                                  replace,
                                  answerIndex,
                                  answer
                                )}
                              />
                            </div>
                          )}
                        </div>
                      )
                    );
                  }
                )}
              </div>
            </div>
          </Form>
        );
      }}
    </FieldArray>
  );
}
TestAnswerForm.propTypes = {
  question: PropTypes.object.isRequired,
  questionIndex: PropTypes.number.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  mode: PropTypes.string.isRequired,
  isDicom: PropTypes.bool.isRequired,
  formRef: PropTypes.object.isRequired
};
export default TestAnswerForm;
